import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/au.awbridal.com/html/src/components/Craftsmanship/craftsmanship.js");
